import gql from 'graphql-tag';
import { ShopFragmentMainEndpoint } from '../fragments/shops.mainEndpoint';

const ShopsQuery = {
  getShops: gql`
    query getShops {
      getShops {
        ...ShopFragmentMainEndpoint
      }
    }
    ${ShopFragmentMainEndpoint}
  `,
  getShops2: gql`
    query getShops2 {
      getShops2 {
        shops {
          ...ShopFragmentMainEndpoint
        }
        imagesLandingOysterMain {
          id
          attachmentsItems {
            description
            attachmentsItem {
              tempFullFilePath
            }
          }
        }
      }
    }
    ${ShopFragmentMainEndpoint}
  `
};

export default ShopsQuery;
